import script from "./BaseFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFooter.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFooter.vue?vue&type=style&index=0&id=d5d64eda&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5d64eda"]])

export default __exports__